<template>
  <div class="contain">
    <el-collapse-transition>
      <!-- 历史记录 收起状态，仅展示功能图标 -->
      <div class="shrink" v-if="!isPack">
        <div class="title">{{ $t('History') }}</div>
        <div class="icon-list" v-if="this_helmetType !== 0 && this_helmetType !== 4 && this_helmetType">
          <div class="icon-block" @click="targetTab('video')" v-if="this_helmetType !== 4">
            <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/video.png" />
            <img v-else class="icon" src="@/icon/re-new-command/video-m.png" />
            <span class="fz14 black mt2">{{ $t('videoS') }}</span>
          </div>
          <div class="line" v-if="this_helmetType !== 4"></div>
          <!-- 仅公有云版本存在视频监控页签 -->
          <!-- <template v-if="isCloud">
            <div class="icon-block" @click="targetTab('Recording')" v-if="this_helmetType !== 4">
              <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/import.png" />
              <img v-else class="icon" src="@/icon/re-new-command/import-m.png" />

              <span class="fz14 black mt2">监控录制</span>
            </div>
            <div class="line" v-if="this_helmetType !== 4"></div>
          </template> -->
          <div class="icon-block" @click="targetTab('trail')" v-if="this_helmetType !== 4">
            <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/track.png" />
            <img v-else class="icon" src="@/icon/re-new-command/track-m.png" />

            <span class="fz14 black mt2">{{ $t('trajectory') }}</span>
          </div>
          <div class="line" v-if="this_helmetType !== 4"></div>
          <div class="icon-block" @click="targetTab('photo')" v-if="this_helmetType !== 4">
            <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/pic.png" />
            <img v-else class="icon" src="@/icon/re-new-command/pic-m.png" />

            <span class="fz14 black mt2">{{ $t('pictureS') }}</span>
          </div>
          <div class="line" v-if="this_helmetType !== 4"></div>
          <div class="icon-block" @click="targetTab('deviceDetail')" v-if="this_helmetType !== 4">
            <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/device.png" />
            <img v-else class="icon" src="@/icon/re-new-command/device-m.png" />

            <span class="fz14 black mt2">{{ $t('EquipmentStatus') }}</span>
          </div>
          <div class="line none" v-if="this_helmetType !== 4"></div>
        </div>
        <div
          class="icon-list jls_icons"
          :class="this_helmetType === 4 ? 'one-icon' : ''"
          v-if="this_helmetType === 0 || this_helmetType === 4"
        >
          <div class="icon-block" @click="targetTab('jlstrail')">
            <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/track.png" />
            <img v-else class="icon" src="@/icon/re-new-command/track-m.png" />

            <p class="fz14 black mt2">{{ $t('trajectory') }}</p>
          </div>
          <div class="line" v-if="this_helmetType !== 4"></div>
          <div class="icon-block" @click="targetTab('jlsDeviceDetail')" v-if="this_helmetType !== 4">
            <img v-if="isDefaultTheme" class="icon" src="@/icon/re-new-command/device.png" />
            <img v-else class="icon" src="@/icon/re-new-command/video-m.png" />

            <p class="fz14 black mt2">{{ $t('EquipmentStatus') }}</p>
          </div>
        </div>
        <div class="extend-up cursor" @click="triggerPack" v-if="!isPack">
          <span>{{ $t('openS') }}</span>
          <i></i>
        </div>
      </div>
      <!-- 历史记录 展开状态，完整列表展示 -->
      <div class="extend" v-else>
        <div class="title">{{ $t('History') }}</div>
        <!-- 标签页 -->
        <div class="main view-info">
          <!-- 查询条件 -->
          <el-form :inline="true" label-width="40px">
            <!-- 设备状态详情页签 只有一个结束时间查询条件 -->
            <el-form-item v-if="activeName === 'deviceDetail'" class="deviceDetail-class">
              <el-date-picker
                v-model="listDataQuery.deviceDetail.logTimestampEnd"
                type="datetime"
                placeholder="选择时间"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :clearable="false"
                @change="pageChange"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
            <!-- 其它页签 时间范围查询条件 -->
            <el-form-item
              v-if="activeName != 'deviceDetail' && activeName != 'jlsDeviceDetail'"
              class="deviceDetail1-class"
            >
              <el-date-picker
                v-model="query.logTimestampBegin"
                type="datetime"
                :placeholder="$t('pleaseSelecDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                :clearable="false"
                @change="pageChange"
                size="small"
              >
              </el-date-picker>
              <span class="black">~</span>
              <el-date-picker
                v-model="query.logTimestampEnd"
                type="datetime"
                :placeholder="$t('pleaseSelecDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                :clearable="false"
                @change="pageChange"
                size="small"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="deviceDetail2-class">
              <el-select
                v-model="query.helmetId"
                :placeholder="$t('allDevice')"
                size="small"
                :clearable="true"
                @change="_changeHelmet"
                popper-append-to-body
              >
                <el-option
                  v-for="item of userBingDevice"
                  :key="item.deviceSN"
                  :label="item.deviceSN"
                  :value="item.deviceSN"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div
            class="batch-manage"
            v-if="
              activeName !== 'deviceDetail' &&
                activeName !== 'jlsDeviceDetail' &&
                activeName !== 'Recording' &&
                activeName !== 'audio'
            "
          >
            <span class="batch-btn" @click="batchManage" v-if="!showBtns">{{ $t('batchManagement') }}</span>
            <div class="mange-btns" v-else>
              <span class="batch-btn" @click="allSelect">{{ allTxt }}</span>
              <span
                class="batch-btn"
                @click="handleCheckChange('downlown')"
                v-if="activeName === 'photo' || activeName === 'video'"
                >{{ $t('download') }}</span
              >
              <span class="batch-btn" @click="handleCheckChange('import', true)">{{ $t('markImportant') }}</span>
              <span class="batch-btn" @click="handleCheckChange('import', false)">{{ $t('cancelImportant') }}</span>
              <span class="batch-btn" @click="handleCheckChange('delect')" plain>{{ $t('delete') }}</span>
              <span class="batch-btn" @click="batchComplete">{{ $t('complete') }}</span>
            </div>
          </div>
          <el-checkbox-group v-model="checkboxList" class="groups">
            <el-row>
              <el-col :span="24">
                <el-tabs v-model="activeName" type="card" @tab-click="pageChange">
                  <!-- 图片 页签 -->
                  <el-tab-pane
                    :label="$t('pictureS')"
                    name="photo"
                    v-if="
                      userBingDeviceType.includes(1) || userBingDeviceType.includes(2) || userBingDeviceType.includes(3)
                    "
                  >
                    <ul>
                      <li v-for="(d, index) in listData.photo.list" :key="index">
                        <el-checkbox :label="d" class="check-item" v-if="showBtns"></el-checkbox>
                        <div class="box">
                          <el-image
                            :src="d.mediaUrl"
                            :title="d.location"
                            class="pic"
                            :lazy="true"
                            :preview-src-list="previewImgList"
                            @error="srcerr(d.mediaUrl, index)"
                          >
                          </el-image>
                          <img
                            class="important-star"
                            src="@/icon/new-command/history/importStar.png"
                            alt=""
                            v-if="d.importantFlag"
                          />
                        </div>
                        <div class="pic_contrl">
                          <div class="flex_just_between lh20">
                            <h5 class="video-time-pic">
                              <span>{{ d.startTimestamp }}</span>
                            </h5>
                            <div class="flex_just_align_center">
                              <div
                                class="icon20"
                                :class="[d.importantFlag ? 'setNormalImp-icon' : 'setPicImp-icon']"
                                @click="_setImpImg(d.logTimestamp, d.userId, !d.importantFlag)"
                                :title="[
                                  d.importantFlag
                                    ? $t('SetAsNormal') + $t('pictureS')
                                    : $t('SetAsImportant') + $t('pictureS'),
                                ]"
                              ></div>
                              <div
                                class="download-icon icon20"
                                @click="downloadImg(d.path, d.name, d.mediaUrl, null)"
                                :title="$t('download')"
                              ></div>
                              <div
                                v-has="'sys:new:command:media:delete'"
                                class="download-icon-delete icon20"
                                @click="_mediasDelete(d.logTimestamp, d.type, d.userId)"
                                :title="$t('delete')"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <!-- 视频/重要视频 页签 -->
                  <el-tab-pane
                    v-for="tab in [{ name: 'video', label: $t('videoS') }]"
                    :key="tab.name"
                    :label="tab.label"
                    :name="tab.name"
                    v-if="
                      userBingDeviceType.includes(1) || userBingDeviceType.includes(2) || userBingDeviceType.includes(3)
                    "
                  >
                    <div class="exVideo" v-if="videoShow">
                      <vue-draggable-resizable
                        :w="width"
                        :h="height"
                        :x="x"
                        :y="y"
                        :min-width="350"
                        :min-height="250"
                        :parent="false"
                        :grid="[10, 10]"
                        id="amplifyVideo"
                        class-name="dragging1"
                        @dragging="onDrag"
                        @resizing="onResize"
                        :draggable="allowDrag"
                      >
                        <div class="exVideoTitle">
                          <span>{{ $t('History') }}</span>
                          <i class="sys-close-btn" @click="cancleVideoShow"></i>
                        </div>
                        <HistoryVideo
                          :videoSrcArr="playVideoData"
                          :index.sync="index"
                          :videoShow.sync="videoShow"
                          @searchList="searchList"
                          :userData="historyData"
                          @getAllow="getAllow"
                          :width="520"
                          :height="350"
                          
                        >
                        <!-- :allowDrag.sync="allowDrag" -->
                        </HistoryVideo>
                      </vue-draggable-resizable>
                    </div>
                    <ul>
                      <li v-for="(d, index) in listData[tab.name].list" :key="index">
                        <el-checkbox :label="d" class="check-item" v-if="showBtns"></el-checkbox>
                        <div class="box">
                          <!-- <div v-if="d.Played" class="played">{{ $t('Played') }}</div> -->
                          <!-- 已删除 -->
                          <div class="delete" v-if="d.status === 1">
                            <img class="upper" src="@/icon/monitor/delete.png" />
                            <h5 class="upper-text">{{ $t('Deleted') }}</h5>
                          </div>
                          <!-- 未上传 -->
                          <div v-else-if="!d.uploadFlag">
                            <img class="upper" src="@/icon/monitor/notUploaded.png" />
                            <h5 class="upper-text">{{ $t('NotUploaded') }}</h5>
                          </div>
                          <!-- 正常 -->
                          <el-image
                            v-else
                            :src="
                              !d.preMediaUrl
                                ? require(theme === 'default'
                                    ? '@/icon/monitor/coverPlaceLight.png'
                                    : '@/icon/monitor/coverPlaceDark.png')
                                : d.preMediaUrl
                            "
                            @click="playVideo(index)"
                            class="pic"
                            :lazy="true"
                            @error="srcerrVideo(d.preMediaUrl, index)"
                          >
                            <div slot="placeholder" class="image-slot">
                              <img class="place-img" :src="d.preMediaUrl" />
                            </div>
                          </el-image>
                          <img
                            class="important-star"
                            src="@/icon/new-command/history/importStar.png"
                            alt=""
                            v-if="d.importantFlag"
                          />
                        </div>
                        <div class="pic_contrl">
                          <div class="flex_just_between lh20">
                            <h5 class="video-time-pic" v-if="!d.timestampList || d.timestampList.length <= 0">
                              <span>{{ $t('startS') }}：{{ d.logTimestamp }}</span>
                              <span v-if="d.endTimestamp">{{ $t('endS') }}：{{ d.endTimestamp }}</span>
                            </h5>
                            <h5 class="video-time-pic" v-if="!!d.timestampList && d.timestampList.length > 0">
                              <span v-for="timestampStr in d.timestampList">{{ timestampStr }}</span>
                            </h5>
                            <div class="flex_just_align_center">
                              <div
                                class="icon20"
                                :class="[d.importantFlag ? 'setNormalImp-icon' : 'setPicImp-icon']"
                                @click="_setImpVideo(d.logTimestamp, d.userId, !d.importantFlag)"
                                v-if="d.status != 1"
                                :title="[
                                  d.importantFlag
                                    ? $t('SetAsNormal') + $t('videoS')
                                    : $t('SetAsImportant') + $t('videoS'),
                                ]"
                              ></div>
                              <div
                                class="download-icon icon20"
                                @click="downloadImg(d.path, d.name, d.mediaUrl, d)"
                                :title="$t('download')"
                                v-if="d.uploadFlag && d.status != 1"
                              ></div>
                              <div
                                v-has="'sys:new:command:media:delete'"
                                class="download-icon-delete icon20"
                                @click="_mediasDelete(d.logTimestamp, d.type, d.userId)"
                                :title="$t('delete')"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <img
                          v-if="d.status === 0 && d.uploadFlag"
                          @click="playVideo(index)"
                          class="center"
                          src="@/icon/monitor/videoPlay.png"
                        />
                      </li>
                    </ul>
                  </el-tab-pane>
                  <!-- 轨迹 页签 -->
                  <el-tab-pane
                    :label="$t('trajectory')"
                    name="trail"
                    v-if="
                      userBingDeviceType.includes(1) || userBingDeviceType.includes(2) || userBingDeviceType.includes(3)
                    "
                  >
                    <ul>
                      <li v-for="(d, index) in listData.trail.list" :key="index" class="row-list">
                        <el-checkbox :label="d" class="check-item" v-if="showBtns"></el-checkbox>
                        <div class="row-header">
                          <img
                            class="audio"
                            :src="
                              require(isDefaultTheme
                                ? '@/icon/re-new-command/icon_gps.png'
                                : '@/icon/new-common/icon_gps.png')
                            "
                          />
                          <div class="row-title">
                            <span>
                              {{ $t('startS') + ':' + d.startTimestamp }}
                            </span>
                            <span>
                              {{ $t('endS') + ':' + d.endTimestamp }}
                            </span>
                          </div>
                          <img
                            class="important-star"
                            :src="
                              require(isDefaultTheme
                                ? '@/icon/new-command/history/defaultStar.png'
                                : '@/icon/new-command/history/importStar.png')
                            "
                            alt=""
                            v-if="d.importantFlag"
                          />
                        </div>
                        <div class="play-block">
                          <div class="track-hover">
                            <img
                              v-has="'sys:new:command:media:delete'"
                              :title="$t('deleteGPS')"
                              class="imp-trace"
                              src="@/icon/new-command/history/delet.png"
                              @click="_tranceDelete(d.userId, d.sidGroup)"
                            />
                            <img
                              :title="[
                                d.importantFlag
                                  ? $t('SetAsNormal') + $t('trajectory')
                                  : $t('SetAsImportant') + $t('trajectory'),
                              ]"
                              class="delet-trace"
                              :src="[
                                d.importantFlag
                                  ? require('@/icon/new-command/history/track.png')
                                  : require('@/icon/new-command/history/picture.png'),
                              ]"
                              @click="_setImpTrack(d.sidGroup, d.userId, !d.importantFlag)"
                            />
                          </div>
                          <span v-if="d.status === 1" class="delete-tag">{{ $t('Deleted') }}</span>
                          <div v-else class="btn-trail" @click="playTrail(listData.trail.list, index)">
                            <img
                              :src="
                                require(isDefaultTheme
                                  ? '@/icon/re-new-command/icon_play-mini.png'
                                  : '@/icon/new-common/icon_play-mini.png')
                              "
                            />
                            <span>{{ $t('PlayTrack') }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <!-- 音频播放 页签，执法仪设备展示  -->
                  <el-tab-pane v-if="userBingDeviceType.includes(2)" label="音频" name="audio">
                    <ul>
                      <li v-for="(d, index) in listData.audio.list" :key="index" class="row-list">
                        <el-checkbox :label="d" class="check-item" v-if="showBtns"></el-checkbox>
                        <div class="row-header">
                          <img class="audio" src="@/icon/new-common/ic_video.png" />
                          <h5 class="row-title" @click="playAudioIndex = -1">
                            {{ d.logId }}
                          </h5>
                          <span v-if="!d.uploadFlag" class="not-uploaded-tag">
                            未上传
                          </span>
                          <span v-else-if="d.status === 1" class="delete-tag">已删除</span>
                        </div>
                        <audio
                          class="play-audio"
                          v-if="playAudioIndex === index"
                          controls
                          autoplay
                          :src="d.mediaUrl"
                        ></audio>
                        <h5 v-if="playAudioIndex !== index" class="row-time">
                          {{ d.startTimestamp }}
                        </h5>
                        <div class="play-block" v-if="playAudioIndex !== index">
                          <div class="track-hover">
                            <img
                              title="删除音频"
                              class="delet-trace"
                              src="@/icon/new-command/history/delet.png"
                              @click="_mediasDelete(d.logTimestamp, d.type, d.userId)"
                            />
                          </div>
                          <div class="btn-trail" @click="playAudioIndex = index">
                            <img src="@/icon/re-new-command/icon_play-mini.png" />
                            <span>播放音频</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <!-- 设备状态详情 页签 -->
                  <el-tab-pane
                    :label="$t('EquipmentStatus')"
                    name="deviceDetail"
                    v-if="
                      userBingDeviceType.includes(1) || userBingDeviceType.includes(2) || userBingDeviceType.includes(3)
                    "
                  >
                    <table
                      class="status_info"
                      :style="{ height: listData.deviceDetail.HM_SYSTEM !== $t('开启') ? '80px' : '' }"
                    >
                      <tr>
                        <th>{{ $t('QueryTime') }}</th>
                        <td colspan="3">
                          <template>
                            {{ lastQueryTime | datetimeShort }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('EquipmentSwitchStatus') }}</th>
                        <td colspan="3">
                          <template>
                            {{ listData.deviceDetail.HM_SYSTEM != $t('开启') ? $t('关机') : $t('开机') }}
                          </template>
                        </td>
                      </tr>
                      <template v-if="listData.deviceDetail.HM_SYSTEM === $t('开启')">
                        <tr>
                          <th>{{ $t('Power') }}</th>
                          <td colspan="3">
                            {{
                              listData.deviceDetail.logBatteryDto
                                ? listData.deviceDetail.logBatteryDto.dumpEnergy + 'mAh'
                                : '-'
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th>WiFi</th>
                          <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_WIFI === $t('closeN') }">
                            <template>
                              {{ $t(listData.deviceDetail.HM_WIFI) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>4G</th>
                          <td
                            colspan="3"
                            :class="{ 'close-color': listData.deviceDetail.HM_MOBILEDATA === $t('closeN') }"
                          >
                            <template> {{ $t(listData.deviceDetail.HM_MOBILEDATA) }} </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('GPS_BD') }}</th>
                          <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_GPS === $t('closeN') }">
                            <span
                              v-if="listData.deviceDetail.logGpsTraceDataDto && listData.deviceDetail.HM_GPS === $t('开启')"
                              :title="
                                $t('longitude') +
                                  ':' +
                                  listData.deviceDetail.logGpsTraceDataDto.lng +
                                  '，' +
                                  $t('latitude') +
                                  ':' +
                                  listData.deviceDetail.logGpsTraceDataDto.lat
                              "
                            >
                              {{ $t(listData.deviceDetail.HM_GPS) }}
                            </span>
                            <span v-else>
                              {{ $t(listData.deviceDetail.HM_GPS) }}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('Bluetooth') }}</th>
                          <td
                            colspan="3"
                            :class="{ 'close-color': listData.deviceDetail.HM_BLUETOOTH === $t('closeN') }"
                          >
                            <template>
                              {{ $t(listData.deviceDetail.HM_BLUETOOTH) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('cameraHead') }}</th>
                          <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_CAMERA === $t('closeN') }">
                            <template>
                              {{ $t(listData.deviceDetail.HM_CAMERA) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('laser') }}</th>
                          <td colspan="3" :class="{ 'close-color': listData.deviceDetail.HM_LASER === $t('closeN') }">
                            <template>
                              {{ $t(listData.deviceDetail.HM_LASER) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('floodlight') }}</th>
                          <td
                            colspan="3"
                            :class="{ 'close-color': listData.deviceDetail.HM_LEDLIGHT === $t('closeN') }"
                          >
                            <template>
                              {{ $t(listData.deviceDetail.HM_LEDLIGHT) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('temperature') }}</th>
                          <td colspan="3">
                            <template>
                              {{
                                listData.deviceDetail.logExtraDataDto && listData.deviceDetail.logExtraDataDto.envTemp
                                  ? listData.deviceDetail.logExtraDataDto.envTemp + '℃'
                                  : '-'
                              }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('pressure') }}</th>
                          <td colspan="3">
                            <template>
                              {{
                                listData.deviceDetail.logExtraDataDto && listData.deviceDetail.logExtraDataDto.pressure
                                  ? (Number(listData.deviceDetail.logExtraDataDto.pressure) / 10).toFixed(2) + 'kPa'
                                  : '-'
                              }}
                            </template>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </el-tab-pane>
                  <!-- jls轨迹 页签 -->
                  <el-tab-pane
                    :label="$t('jlsTrajectory')"
                    name="jlstrail"
                    v-if="userBingDeviceType.includes(0) || userBingDeviceType.includes(4)"
                  >
                    <ul>
                      <li v-for="(d, index) in listData.jlstrail.list" :key="index" class="row-list">
                        <el-checkbox :label="d" class="check-item" v-if="showBtns"></el-checkbox>
                        <div class="row-header">
                          <img class="audio" src="@/icon/new-common/icon_gps.png" />
                          <div class="row-title">
                            <span>
                              {{ $t('startS') + '：' + d.beginTime }}
                            </span>
                            <span>
                              {{ $t('endS') + '：' + d.endTime }}
                            </span>
                          </div>
                          <img
                            class="important-star"
                            src="@/icon/new-command/history/importStar.png"
                            alt=""
                            v-if="d.importantFlag"
                          />
                        </div>
                        <div class="play-block">
                          <span v-if="d.status === 1" class="delete-tag"> {{ $t('Deleted') }}</span>
                          <div v-else class="btn-trail" @click="playTrail(listData.jlstrail.list, index)">
                            <img src="@/icon/re-new-command/icon_play-mini.png" />
                            <span>{{ $t('PlayTrack') }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <!-- jls设备状态详情 页签 -->
                  <el-tab-pane
                    :label="$t('jlsEquipmentStatus')"
                    name="jlsDeviceDetail"
                    v-if="userBingDeviceType.includes(0)"
                  >
                    <table class="status_info">
                      <tr>
                        <th>{{ $t('time') }}</th>
                        <td colspan="3">
                          <template>
                            {{ listData.jlsDeviceDetail.tempCurrenTime }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('heartRate') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.jlsDeviceDetail.heartRate
                                ? listData.jlsDeviceDetail.heartRate + $t('heartRateUnit')
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('BloodOxygen') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.jlsDeviceDetail.bloodOxygen
                                ? Number(listData.jlsDeviceDetail.bloodOxygen).toFixed(1) + '%'
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('signalIntensity') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.jlsDeviceDetail.signNum
                                ? listData.jlsDeviceDetail.signLever + ':' + listData.jlsDeviceDetail.signNum
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('Power') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.jlsDeviceDetail.freeBattery
                                ? Number(listData.jlsDeviceDetail.freeBattery).toFixed(1) + '%'
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t('pressure') }}</th>
                        <td colspan="3">
                          <template>
                            {{
                              listData.jlsDeviceDetail.altitude
                                ? Number(listData.jlsDeviceDetail.altitude).toFixed(3) + 'kPa'
                                : '-'
                            }}
                          </template>
                        </td>
                      </tr>
                    </table>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </el-checkbox-group>
          <!-- 分页组件 -->
          <el-pagination
            v-if="activeName !== 'deviceDetail' && activeName !== 'jlsDeviceDetail'"
            class="pagination"
            @size-change="pageChange"
            @current-change="searchList(activeName)"
            :current-page.sync="listDataQuery[activeName].pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="query.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="this.listData[this.activeName] ? this.listData[this.activeName].total : 0"
            :pager-count="5"
          >
          </el-pagination>
        </div>
        <div class="pack-up" @click="triggerPack" v-if="isPack">
          <span>{{ $t('Stow') }}</span>
          <i></i>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import { deepClone } from '@/util/common'
import { download, downloadZip } from '@/util/file'
import { formatDate, formatTime, nowDate, now, beforeMonthTime } from '@/util/date'
import { trailGroup, selectRecord } from '@/api/monitor'
import {
  listMediasTag,
  downloadPic,
  mediasDelete,
  tranceDelete,
  rtcDelete,
  setImpImg,
  setImpTrack,
  mediaOperations,
  batchDownloadMedias,
  batchDeleteMedias,
  batchImportance,
} from '@/api/log/mediaTag'
import { findUserBingDeviceLog } from '@/api/helmetManage'
import { listAudio, listAllGps, listAllPhoto, listRecording } from '@/api/log/log'
import { getLogStatus } from '@/api/log/status'
import HistoryVideo from '@/components/new-historyVideo/Index.vue'
import { success, getSession, nextDate } from '@/api/common'
import { isImportantFlag } from '@/api/log/video'
import { loadVideoHitory } from '@/util/historyVideo'
import { mapGetters } from 'vuex'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

var errobj = {}
export default {
  props: {
    historyData: {
      type: Object,
      default: () => {},
    },
    isPack: {
      type: Boolean,
    },
    helmetType: {
      type: Number,
    },
  },
  data() {
    return {
      width: 520,
      height: 350,
      x: 0,
      y: 0,
      allowDrag: true,
      speed: 1.0,
      // 公用查询参数
      query: {
        userId: '',
        helmetId: '',
        logTimestampBegin: formatDate(beforeMonthTime()) + ' 00:00:00',
        logTimestampEnd: formatDate(now()) + ' 23:59:59',
        pageSize: 10,
      },
      // 页签独立查询参数
      listDataQuery: {
        video: { pageNum: 1 },
        importantVideo: { pageNum: 1 },
        Recording: { pageNum: 1, importantFlag: false },
        audio: { pageNum: 1 },
        trail: { pageNum: 1 },
        photo: { pageNum: 1 },
        jlstrail: { pageNum: 1 },
        deviceDetail: {
          pageNum: 1,
          gpsType: 1,
          logTimestampEnd: now(),
        },
        jlsDeviceDetail: {
          logTimestampEnd: nowDate(),
        },
      },
      lastQueryTime: now(),
      // 页签响应数据
      listData: {
        video: {
          total: 0,
          list: [],
        },
        importantVideo: {
          total: 0,
          list: [],
        },
        Recording: { total: 0, list: [] },
        audio: {
          total: 0,
          list: [],
        },
        trail: {
          total: 0,
          list: [],
        },
        photo: {
          total: 0,
          list: [],
        },
        deviceDetail: {},
        jlstrail: {
          total: 0,
          list: [],
        },
        jlsDeviceDetail: {},
      },
      // 默认打开页签：图片
      activeName: 'video',
      // 播放音频索引
      playAudioIndex: -1,
      // 播放器开关
      videoShow: false,
      recordingVideoShow: false,
      // 当前播放视频列表
      playVideoData: [],
      // 当前选中的video index
      index: null,
      tabType: '',
      coverSrc: require('@/icon/monitor/coverPlaceDark.png'),
      theme: localStorage.getItem('theme'),
      // 用户绑定设备历史记录
      userBingDevice: [],
      userBingDeviceType: [],
      this_helmetType: this.helmetType,
      // 显示批量管理按钮
      showBtns: false,
      // 所有选择数据
      checkboxList: [],
      // 选中过滤需要的参数后的数据
      allChecked: [],
      allTxt: this.$t('selectAll'),
    }
  },
  computed: {
    ...mapGetters(['isCloud', 'isDefaultTheme']),
    // 计算图片预览组件的预览图数组
    previewImgList() {
      return this.listData.photo.list.map(i => {
        return i.mediaUrl
      })
    },
    item() {
      return this.$store.state.currentHelmetData
    },
  },
  components: {
    HistoryVideo,
    VueDraggableResizable,
  },
  mounted() {
    // 首次渲染没有触发watch，手动触发
    this.query.helmetId = this.historyData.deviceName
    this.query.userId = this.historyData.userId
    this._findUserBingDeviceLog(this.historyData.deviceName)
    if (this.historyData.deviceName) {
      this.userBingDeviceType.push(this.historyData.specType)
      if (this.historyData.specType === 0) {
        this.activeName = 'jlstrail'
      } else if (this.historyData.specType === 4) {
        this.activeName = 'jlstrail'
      } else {
        this.activeName = 'photo'
      }
      this.searchList()
    }
  },
  methods: {
    getAllow(type,w,h,x,y) {
      this.allowDrag = type
      this.width = w ? w : this.width
      this.height = h ? h : this.height 
      this.x = x+'' ? x : this.x
      this.y = y+'' ? y : this.y
    },
    // 全选当前页
    allSelect() {
      this.allTxt = this.allTxt === this.$t('selectAll') ? this.$t('deselectDll') : this.$t('selectAll')
      if (this.allTxt === this.$t('deselectDll')) {
        this.checkboxList = this.listData[this.activeName].list
      } else {
        this.checkboxList = []
        this.allChecked = []
      }
    },
    // 批量下载
    batchDownlown() {
      batchDownloadMedias(this.allChecked).then(res => {
        if (res['type'] !== 'text/xml') {
          this.$message({
            message: this.$t('downloadFile'),
            type: 'warning',
          })
          return
        } else {
          downloadZip(res, this.historyData.deviceName)
        }
        this.checkboxList = []
        this.allChecked = []
        this.allTxt = this.$t('selectAll')
      })
    },
    // /批量重要
    batchImportant(data) {
      let param = {
        ids: this.allChecked,
        importantFlag: data ? 1 : 0,
      }
      batchImportance(param).then(res => {
        if (res.state === 0) {
          this.checkboxList = []
          this.searchList(this.activeName)
          this.allTxt = this.$t('selectAll')
          success(data ? this.$t('markSuccessfully') : this.$t('unmarkSuccessful'))
        }
      })
    },
    // 批量删除
    batchDelect() {
      batchDeleteMedias(this.allChecked).then(res => {
        if (res.state === 0) {
          this.checkboxList = []
          this.searchList(this.activeName)
          this.allTxt = this.$t('selectAll')
          success(this, this.$t('deleteSuccess'))
        }
      })
    },
    // 点击完成管理
    batchComplete() {
      this.checkboxList = []
      this.showBtns = false
      this.allTxt = this.$t('selectAll')
    },
    // type:处理类型，val:处理值
    handleCheckChange(type, val) {
      if (this.checkboxList.length === 0) {
        this.$message({
          message: '请先选择要操作的数据',
          type: 'warning',
        })
        return
      }
      if (type === 'downlown') {
        if (
          (this.activeName === 'video' &&
            this.checkboxList &&
            this.checkboxList.length === 1 &&
            !this.checkboxList[0].uploadFlag) ||
          this.checkboxList[0].status === 1
        ) {
          this.$message({
            message: this.$t('iploadFileDoesnoSupport'),
            type: 'warning',
          })
          return
        }
      }

      this.allChecked = []
      this.checkboxList.map((item, index) => {
        if (
          this.activeName === 'video' ||
          this.activeName === 'importantVideo' ||
          this.activeName === 'Recording' ||
          this.activeName === 'photo'
        ) {
          if (this.activeName === 'video' && type === 'downlown') {
            if (item.uploadFlag && item.status !== 1) {
              this.allChecked.push({
                userId: item.userId,
                logTimestamp: item.logTimestamp,
                type: item.type,
                groupActual: item.groupActual ? item.groupActual : '',
              })
            }
          } else {
            this.allChecked.push({
              userId: item.userId,
              logTimestamp: item.logTimestamp,
              type: item.type,
              groupActual: item.groupActual ? item.groupActual : '',
            })
          }
        } else if (this.activeName === 'trail' || this.activeName === 'jlstrail') {
          this.allChecked.push({
            userId: item.userId,
            logTimestamp: '',
            type: 3,
            groupActual: item.sidGroup ? item.sidGroup : '',
          })
        }
      })
      if (type === 'import') {
        this.batchImportant(val)
      } else if (type === 'delect') {
        this.batchDelect()
      } else if (type === 'downlown') {
        this.batchDownlown()
      }
    },
    // 点击批量管理
    batchManage() {
      this.showBtns = true
      this.allTxt = this.$t('selectAll')
    },
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function(x, y) {
      this.x = x
      this.y = y
    },
    triggerPack() {
      this.$emit('update:isPack', !this.isPack)
      this.recordingVideoShow = false
      this.videoShow = false
    },
    targetTab(type) {
      this.$emit('update:isPack', !this.isPack)
      this.recordingVideoShow = false
      this.videoShow = false
      this.activeName = type
      this.searchList(type)
      // 清空批量选择
      this.checkboxList = []
      this.allChecked = []
      this.allTxt = this.$t('selectAll')
    },
    // 页面改变需要查询，套一层是为了防止默认参数传递
    pageChange() {
      if (this.activeName != 'Recording') {
        this.recordingVideoShow = false
      } else if (this.activeName != 'video') {
        this.videoShow = false
      }
      this.listDataQuery[this.activeName]['pageNum'] = 1
      this.searchList()
      this.checkboxList = []
      this.allChecked = []
      this.allTxt = this.$t('selectAll')
    },
    // 查询列表数据
    searchList(activeName) {
      // 如果不指定，查询当前tab数据
      if (!activeName) {
        activeName = this.activeName
      }
      if (!this.item.serialNumber) {
        this.item.serialNumber = this.item.deviceName
      }
      // 当绑定一个用户时才会进行查询
      this.listData[activeName]['list'] = []
      if (this.query.userId) {
        // 拼接查询条件
        let query = Object.assign(deepClone(this.query), this.listDataQuery[activeName])
        console.log(query, 'query', beforeMonthTime())
        if (query.logTimestampBegin) {
          query.logTimestampBegin = formatTime(query.logTimestampBegin)
        }
        if (query.logTimestampEnd && activeName !== 'deviceDetail') {
          // 除设备详情信息外 所有页签结束时间设置为每天最后一秒
          query.logTimestampEnd = formatTime(query.logTimestampEnd)
        }
        this.tabType = ''
        switch (activeName) {
          case 'video':
          case 'importantVideo':
            this.index = null
            query.groupActual = 1
            listMediasTag(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'Recording':
            let param = {
              userId: '',
              helmetId: this.query.helmetId,
              limit: 10,
              offset: (this.listDataQuery[activeName].pageNum - 1) * query.pageSize,
              logTimestampBegin: query.logTimestampBegin,
              logTimestampEnd: query.logTimestampEnd,
            }
            this.tabType = 'Recording'
            listRecording(param).then(res => {
              if (res.state === 0) {
                this.listData[activeName].list = res.data.mediaList
                this.handleVideo(activeName, res.data.mediaList)
                if (this.listData[activeName].list && this.listData[activeName].list.length > 0) {
                  for (let item of this.listData[activeName].list) {
                    if (item.mediaUrlHttps) {
                      item.mediaUrl = item.mediaUrlHttps
                    }
                  }
                }
                this.listData[activeName].total = res.data.totalCount
              }
            })
            break
          case 'audio':
            query.specType = 2
            listAudio(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'trail':
            listAllGps(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'photo':
            listAllPhoto(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'deviceDetail':
            // 删除拷贝的开始时间属性
            query.userId = this.query.userId
            query.helmetId = this.query.helmetId
            delete query['logTimestampBegin']
            // 记录最近一次查询时间
            this.lastQueryTime = query.logTimestampEnd
            getLogStatus(query).then(data => {
              this.setData(data, activeName)
            })
            break
          case 'jlstrail':
            let trailGroupParam = {
              userId: this.query.userId,
              deviceName: this.query.deviceName,
              beginTime: formatDate(query.logTimestampBegin),
              endTime: formatDate(query.logTimestampEnd),
              pageNum: query.pageNum,
              pageSize: query.pageSize,
            }
            trailGroup(trailGroupParam).then(res => {
              this.listData[activeName] = res.data
            })
            break
          case 'jlsDeviceDetail':
            let helmetId = this.query.helmetId
            if (!helmetId) {
              let jlsHelmet = this.userBingDevice.filter(h => h.specType === 0)
              if (jlsHelmet.length > 0) {
                helmetId = jlsHelmet[0].deviceSN
              }
            }
            let jlsDeviceDetailParam = {
              userId: this.query.userId,
              deviceName: helmetId,
              startTime: nowDate().replace(/-/g, '/'),
              endTime: nextDate(),
              limit: 1,
              healthLimit: 1,
            }
            selectRecord(jlsDeviceDetailParam).then(res => {
              if (res.state === 0) {
                let baseStationPage = res.data.baseStationPage
                let deviceStatusPage = res.data.deviceStatusPage
                let healthStatusPage = res.data.healthStatusPage
                let locationPage = res.data.locationPage
                let jlsSignInfo = {}
                if (baseStationPage && baseStationPage[0]) {
                  jlsSignInfo.signNum = baseStationPage[0].rss
                  if (jlsSignInfo.signNum > -75) {
                    jlsSignInfo.signLever = this.$t('strong')
                  } else if (jlsSignInfo.signNum < -85) {
                    jlsSignInfo.signLever = this.$t('weak')
                  } else {
                    jlsSignInfo.signLever = this.$t('centre')
                  }
                }
                if (healthStatusPage && healthStatusPage.recordList && healthStatusPage.recordList[0]) {
                  jlsSignInfo.tempCurrenTime = healthStatusPage.recordList[0].timestamp.split('T')[0]
                  jlsSignInfo.bloodOxygen = healthStatusPage.recordList[0].bloodOxygen
                  jlsSignInfo.heartRate = healthStatusPage.recordList[0].heartRate
                }
                if (deviceStatusPage && deviceStatusPage[0]) {
                  jlsSignInfo.tempCurrenTime = !jlsSignInfo.tempCurrenTime
                    ? deviceStatusPage[0].timestamp.split('T')[0]
                    : jlsSignInfo.tempCurrenTime
                  jlsSignInfo.freeBattery = deviceStatusPage[0].freeBattery
                }
                if (locationPage && locationPage[0]) {
                  if (locationPage[0]) {
                    jlsSignInfo.altitude = locationPage[0].pressure / 1000
                  }
                }
                this.listData[activeName].list = {}
                this.listData[activeName] = jlsSignInfo
              }
            })
        }
      }
    },
    setData(data, activeName) {
      if (data.state === 0) {
        // 设备状态详情状态抽取赋值
        this.listData[activeName].list = []
        if (activeName === 'deviceDetail' && data.value.moduleStatusDtos) {
          data.value.moduleStatusDtos.forEach(item => {
            data.value[item.propertyKey] = item.eventFmt
          })
        }
        if (activeName === 'video') {
          this.handleVideo(activeName, data.value.list)
        }
        this.listData[activeName] = data.value
      }
    },
    handleVideo(activeName, data) {
      let history = loadVideoHitory(this.item)
      if (history.length > 0 && data.length > 0) {
        for (let item of history) {
          let index = data.findIndex(i => {
            return i.name === item.name
          })
          if (index >= 0) {
            data[index].Played = true
          }
        }
      }
      this.listData[activeName].list = data
    },
    // 播放视频
    playVideo(index, isRecording = false) {
      if (isRecording) {
        this.recordingVideoShow = true
        this.videoShow = false
        // 深拷贝赋值
        this.playVideoData = JSON.parse(JSON.stringify(this.listData.Recording.list))
      } else {
        this.recordingVideoShow = false
        this.videoShow = true
        // 深拷贝赋值
        this.playVideoData = JSON.parse(JSON.stringify(this.listData.video.list))
      }
      this.index = index
    },
    // 播放轨迹
    playTrail(data, index) {
      // 存储页码、总页数
      let pageNum = this.listDataQuery[this.activeName].pageNum || 1
      // 总页数
      let total = this.listData[this.activeName].total
        ? Math.ceil(this.listData[this.activeName].total / this.query.pageSize)
        : 0
      this.$store.commit('updateTrailQuery', this.query)
      this.$store.commit('updateTrailPageNum', pageNum)
      this.$store.commit('updateTrailTotal', total)
      // 存储轨迹数据
      this.$store.commit('updatePlayTrail', true)
      this.$store.commit('updateTrailData', data)
      this.$store.commit('updateTrailIndex', index)
      // 关闭控制面板弹窗
      // this.$store.commit('NewStatusPanFlag', false)
      // 轨迹播放控制其他组件隐藏
      this.$store.commit('isPlayTrack', false)
      this.$emit('update:isPack', false)
      this.$store.commit('jlsTrackList', false)
      this.$emit('closePopup')
    },
    // 下载文件
    download(src) {
      download(src)
    },
    // 图片加载失败后触发error的函数：
    srcerr(item, index) {
      // console.log(item, index)
      // 判断该图片的链接是否以err开头,第一次没触发error。
      if (/^err/.test(item)) {
        // 把截掉err的链接重新赋值回imgList，imgList更新又赋值链接给图片，到目前为止该图片已经重新请求了一次正确的地址，正常情况下图片会成功渲染
        this.listData.photo.list[index].mediaUrl = item.slice(3)
        this.$set(this.listData.photo.list, index, this.listData.photo.list[index])
      } else {
        // 判断data里定义好的errobj对象里是否存在该条链接，不存在则保存在errobj里对应的值为1。
        if (!errobj[index]) {
          errobj[index] = 1
        } else {
          // 最多3次请求的机会，超过3次链接不会拼接err，失败的error就不会再触发
          if (errobj[index] > 2) {
            return
          } else {
            errobj[index] += 1
          }
        }
        this.listData.photo.list[index].mediaUrl = 'err' + item
        this.$set(this.listData.photo.list, index, this.listData.photo.list[index])
      }
    },
    srcerrVideo(item, index) {
      // 判断该图片的链接是否以err开头,第一次没触发error。
      if (/^err/.test(item)) {
        // 把截掉err的链接重新赋值回imgList，imgList更新又赋值链接给图片，到目前为止该图片已经重新请求了一次正确的地址，正常情况下图片会成功渲染
        this.listData.video.list[index].preMediaUrl = item.slice(3)
        this.$set(this.listData.video.list, index, this.listData.video.list[index])
      } else {
        // 判断data里定义好的errobj对象里是否存在该条链接，不存在则保存在errobj里对应的值为1。
        if (!errobj[index]) {
          errobj[index] = 1
        } else {
          // 最多3次请求的机会，超过3次链接不会拼接err，失败的error就不会再触发
          if (errobj[index] > 2) {
            return
          } else {
            errobj[index] += 1
          }
        }
        this.listData.video.list[index].preMediaUrl = 'err' + item
        this.$set(this.listData.video.list, index, this.listData.video.list[index])
      }
    },
    // 下载图片
    downloadImg(path, name, url, media) {
      if (media && media.groupVideoList && media.groupVideoList.length > 0) {
        this.$confirm(this.$t('downLoadThisFile1') + media.groupVideoList.length + this.$t('downLoadThisFile2'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(async () => {
          for (let item of media.groupVideoList) {
            if (item.mediaUrl) {
              await downloadPic(item.path, item.name).then(res => {
                this.downImg(item.name, res)
              })
            }
          }
        })
      } else if (url) {
        downloadPic(path, name).then(res => {
          this.downImg(name, res)
        })
      }
    },
    // 媒体文件删除
    _mediasDelete(logTimestamp, type, userId) {
      if (logTimestamp) {
        this.$confirm(this.$t('deleteThisFile'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          mediasDelete(logTimestamp, type, userId).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.searchList()
              if (this.activeName === 'photo') {
                this.handleDelectOperat(103)
              } else if (this.activeName === 'audio') {
                this.handleDelectOperat(100)
              } else if (this.activeName === 'video') {
                this.handleDelectOperat(105)
              } else if (this.activeName === 'importantVideo') {
                this.handleDelectOperat(102)
              }
            }
          })
        })
      }
    },
    // 设置重要图片
    _setImpImg(logTimestamp, userId, importantFlag) {
      let param = {
        importantFlag: importantFlag,
        logTimestamp: logTimestamp,
        type: 2,
        userId: userId,
      }
      setImpImg(param).then(res => {
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.searchList()
        }
      })
    },
    // 设置重要视频
    _setImpVideo(logTimestamp, userId, importantFlag) {
      let param = {
        importantFlag: importantFlag,
        logTimestamp: logTimestamp,
        type: 1,
        userId: userId,
      }
      isImportantFlag(param).then(res => {
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.searchList()
        }
      })
    },
    // 设置重要轨迹
    _setImpTrack(sidGroup, userId, importantFlag) {
      let param = {
        importantFlag: importantFlag,
        sidGroup: sidGroup,
        userId: userId,
      }
      setImpTrack(param).then(res => {
        // console.log(res)
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.searchList()
        }
      })
    },
    // 轨迹删除
    _tranceDelete(userId, sidGroup) {
      if (userId) {
        this.$confirm(this.$t('deleteThisFile'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          tranceDelete(userId, sidGroup).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.searchList()
              this.handleDelectOperat(101)
            }
          })
        })
      }
    },
    // rtc 视频删除
    _rtcDelete(fileId) {
      if (fileId) {
        this.$confirm(this.$t('deleteThisFile'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          rtcDelete(fileId).then(res => {
            if (res.state === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
              })
              this.searchList()
              this.handleDelectOperat(104)
            }
          })
        })
      }
    },
    // 删除媒体数据记录操作
    handleDelectOperat(type) {
      let param = [
        {
          childOperation: type,
          event: -1,
          logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
          loginUserName: getSession('username'),
          operation: '删除媒体数据',
          remoteHelmetId: this.item.deviceName,
          remoteUserId: this.item.userId,
          remoteUserName: this.item.userName,
        },
      ]
      mediaOperations(param)
    },
    // 下载图片
    downImg(file_name, content) {
      if (!file_name) {
        file_name = Date.parse(new Date().toString()) + ".mp4"
      } else if (file_name.indexOf('.mp4') < 0 && file_name.indexOf('.jpg') < 0) {
        file_name = file_name + ".mp4"
      }
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, file_name)
      }
      // for Non-IE (chrome, firefox etc.)
      else {
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = file_name
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    cancleVideoShow() {
      this.videoShow = false
      this.recordingVideoShow = false
      this.allowDrag = true
      this.width = 520
      this.height = 350
      this.x = 0
      this.y = 0
      this.searchList()
    },
    // 获取用户绑定设备
    _findUserBingDeviceLog(deviceName) {
      this.userBingDevice = []
      if(!this.query.userId) return
      findUserBingDeviceLog({ userId: this.query.userId }).then(res => {
        if (res.state === 0) {
          this.userBingDevice = res.data
          if (!deviceName && this.userBingDevice && this.userBingDevice.length > 0) {
            if (this.userBingDevice && this.userBingDevice.length > 0) {
              this.query.helmetId = this.userBingDevice[0].deviceSN
              this.userBingDeviceType = []
              this.userBingDeviceType.push(this.userBingDevice[0].specType)
              this.this_helmetType = this.userBingDevice[0].specType
              if (this.userBingDevice[0].specType === 0 || this.userBingDevice[0].specType === 4) {
                this.activeName = 'jlstrail'
              } else {
                this.activeName = 'photo'
              }
              this.searchList()
            } else {
              this.this_helmetType = null
            }
          }
        }
      })
    },
    // 选择设备序列号
    _changeHelmet(val) {
      this.userBingDeviceType = []
      if (!val) {
        this.userBingDevice.forEach(h => {
          this.userBingDeviceType.push(h.specType)
        })
        if (this.userBingDeviceType && this.userBingDeviceType.length > 0) {
          let helmetType = 0
          if (this.userBingDeviceType.indexOf(2) > -1) {
            helmetType = 2
          } else if (this.userBingDeviceType.indexOf(1) > -1) {
            helmetType = 1
          }
          if (this.this_helmetType != helmetType) {
            if (
              (this.userBingDeviceType.length === 1 && this.userBingDeviceType[0] === 0) ||
              (this.userBingDeviceType.length === 1 && this.userBingDeviceType[0] === 4)
            ) {
              this.activeName = 'jlstrail'
            } else {
              this.activeName = 'photo'
            }
          }
          this.this_helmetType = helmetType
        }
      } else {
        let helmet = this.userBingDevice.filter(h => h.deviceSN === val)
        if (helmet && helmet.length > 0) {
          if (this.this_helmetType != helmet[0].specType) {
            if (helmet[0].specType === 0 || helmet[0].specType === 4) {
              this.activeName = 'jlstrail'
            } else {
              this.activeName = 'photo'
            }
          }
          this.this_helmetType = helmet[0].specType
          this.userBingDeviceType.push(helmet[0].specType)
        }
      }
      this.query.helmetId = val
      this.searchList()
    },
  },
  watch: {
    historyData: {
      handler(val) {
        this.showBtns = false
        this.query.userId = val.userId
        this.query.helmetId = val.deviceName
        this.userBingDeviceType = []
        // 关闭视频播放窗口
        this.recordingVideoShow = false
        this.videoShow = false
        if (val.deviceName) {
          this.userBingDeviceType.push(val.specType)
          if (this.this_helmetType != val.specType) {
            if (val.specType === 0 || val.specType === 4) {
              this.activeName = 'jlstrail'
            } else {
              this.activeName = 'photo'
            }
          }
          this.this_helmetType = val.specType
          this.listDataQuery[this.activeName]['pageNum'] = 1
          this.searchList()
        }
        this._findUserBingDeviceLog(val.deviceName)
      },
      deep: true,
    },
    helmetType: {
      immediate: true,
      handler(val) {
        if (val === 0 || val === 4) {
          this.activeName = 'jlstrail'
        } else {
          if (this.activeName === 'jlstrail' || this.activeName === 'jlsDeviceDetail') {
            this.activeName = 'photo'
          }
        }
        this.this_helmetType = val
      },
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/common.styl'
.close-color
  color #989898
#amplifyVideo
  pointer-events: auto
  background #fff
  position fixed
  left: 30%
  top: 20%
  width 520px
  // height 400px
  // padding 4px
  border: 1px solid rgba(0, 222, 255, 0.5)
  z-index: 9999
.contain
  position relative
  width 100%
  height 100%
  border-radius: 4px;
  .shrink
    width 100%
    height 100%
    background #fff
    position: absolute;
    transition: width 0.5s
    border-radius 4px
    .title
      font-size: 20px;
      font-weight: bold;
      color: #0E65DD;
      text-align center
      bg-image('~@/icon/new-command/history/shrink-bg.png')
      line-height: 46px;

    .icon-list
      display flex
      flex-direction: column;
      align-items: center
      justify-content: space-around
      height: 93%;
      margin-top 20px
      .icon-block
        display flex
        flex-direction: column;
        align-items: center
      .line
        width 75%
        height: 1px;
        background: #D1DAE7;
        opacity: 0.5;
      .none
        visibility hidden
    .one-icon
      justify-content start
    .jls_icons
      justify-content start
      .icon-block
        height 180px
        justify-content center
    .extend-up
      height 63px
      width 24px
      bg-image('~@/icon/re-new-command/history/shrink.png')
      position absolute
      bottom 0
      left -23px
      cursor pointer
      writing-mode: vertical-lr;
      span
        font-size: 12px
        color #0E65DD
        position absolute
        top: 13px;
        left: 6px;
      i
        width 10px
        height 10px
        bg-image('~@/icon/re-new-command/arrow-left.png')

        display: inline-block;
        position: absolute;
        bottom: 3px;
        left: 7px;
  .extend
    // bg-image('~@/icon/new-command/history/extend-bg.png')
    position: absolute;
    width: 548px;
    height: 100%;
    right: -4px;
    transition: width 0.5s
    background #fff
    border-radius: 4px;
    .title
      font-size: 18px;
      font-weight: bold;
      color: #0E65DD;
      position: absolute;
      top: 0;
      left: 0;
      width: 86%;
      padding-left: 72px;
      line-height: 46px;
      bg-image('~@/icon/re-new-command/img-head.png')
      border-radius: 4px;
    .exVideo
      background #fff
      position fixed
      border: 1px solid rgba(0, 222, 255, 0.5);
      z-index: 999
      .exVideoTitle
        color #0E65DD
        display flex
        justify-content: space-between;
        align-items: center;
        background url('~@/icon/newBg/img_head1.png') no-repeat
        background-size 100% 39px
        padding-left 50px
        line-height 39px
        span
          font-size: 18px;
          font-weight: bold;
        .sys-close-btn
            margin-right 5px
    .reRxVideo
      background #fff
      position fixed
      border: 1px solid rgba(0, 222, 255, 0.5);
      z-index: 999
      .exVideoTitle
        padding-bottom: 10px;
        color #0E65DD
        display flex
        justify-content: space-between;
        align-items: center;
        span
          font-size: 18px;
          font-weight: bold;
        .sys-close-btn
            margin-right 5px
    .main
      margin: 50px 10px 10px 10px;
      height: calc( 100% - 50px );
      .batch-manage
        margin-bottom 10px
        .batch-btn
          fons-size 16px
          color #0e65dd
          margin-right 10px
          font-weight 600
          cursor pointer
      >>>.el-tab-pane
        height 100%
      ul
        margin-top 10px
        height 100%
        overflow-y auto
        li
          width 46%
          height 143px
          position relative
          margin-left 3%
          float left
          cursor default
          .check-item
            position absolute;
            top 0;
            left 0;
            z-index 1
            >>>.el-checkbox__label
                display: none
          .pic_contrl
            width 100%
            position: absolute;
            bottom: 13px;
            left: 1px;
            background rgba(0, 0, 0,0.6)
            .video-time-pic
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size 12px
              font-weight 400
              color #fff
              line-height: 16px;
              overflow: hidden
              text-overflow: ellipsis
              white-space: nowrap
              span
                margin-left 9px
                font-size 12px
          &:hover .download-icon
            display block
          &:hover .download-icon-delete
            display block
          &:hover .setPicImp-icon, &:hover .setNormalImp-icon
            display block
          &:hover .video-time
            // width calc(100% - 45px)
            // overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .box
            width 100%
            height 130px
            border-radius 4px
            border: 1px solid #00A0E9;
            .played
              position: absolute
              top 1px
              left 1px
              color var(--tree-black)
              background var(--new-tab-bg)
              width: fit-content
              height 16px
              border-radius 4px
              font-size 12px
              padding 5px
              z-index 9
            .important-star
              position: absolute
              top 1px
              right 1px
            .pic
              width 100%
              height 100%
              cursor pointer
              border-radius 4px
              object-fit fill
            div
              height 100%
              width 100%
              background #E4EAF2
            div.delete
              background #FFF6F6
            video
              width 100%
              height 100%
              cursor pointer
          .video-name
            font-size 14px
            font-weight 400
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
          .download-icon
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/download.png')
          .setPicImp-icon
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/picture.png')
          .setNormalImp-icon
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/track.png')
          .download-icon-delete
            display none
            cursor pointer
            margin-left 2px
            bg-image('~@/icon/new-command/history/delet.png')
          .video-time
            width: 100%;
            height: 29px;
            font-size 14px
            font-weight 400
            color #fff
            line-height: 29px;
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            position: absolute;
            bottom: 20px;
            left: 1px;
            background rgba(0, 0, 0, 0.6)
            span
              margin-left 9px
          .upper
            position absolute
            top 20px
            left 50%
            transform translate(-50%, 0)
            width 40px
            height 40px
          .place-img
            width 100%
            height 100%
          .upper-text
            position absolute
            top 70px
            left 50%
            transform translate(-50%, 0)
            font-size 14px
            font-weight 400
            color #4ABE7B
          .delete .upper-text
            color #B41616
          .center
            position absolute
            top 35px
            left 96px
            width 40px
            heigth 40px
            cursor: pointer
            .video-delete
              position absolute
              bottom 18px
              right 23px
              cursor pointer
            .download
              position absolute
              bottom 18px
              right 0
              cursor pointer
        // 一列布局样式
        .row-list
          height 110px
          width 90%
          margin 0 5%
          display flex
          justify-content space-between
          align-items center
          border-bottom 1px solid rgba(220, 223, 230, 1);
          audio
            height 34px
          .important-star
            margin-right 10px
          .row-header
            display flex
            align-items center
            .audio
              width 60px
              height 60px
              margin-right 10px
            .row-title
              display flex
              font-size 14px
              font-weight 400
              margin-right 20px
              color #333
              flex-direction: column;
              cursor: pointer;
              // min-width: 255px;
          .play-block
            .track-hover
              display none
            .btn-trail
              display flex
              justify-content space-evenly
              align-items center
              width 90px; /* no */
              height 30px
              background var(--history-btn-trail-bg)
              border var(--history-btn-trail-border)
              border-radius 4px
              cursor pointer
              color #16326F
            .imp-trace
              cursor pointer
              float right
              // display none
            .delet-trace
              padding-right 7px
              margin-bottom 10px
              cursor pointer
              float right
              // display none
            .delete-tag
              width 50px
              height 24px
              line-height 24px
              text-align center
              background #B41616
              border-radius 4px 0px 4px 0px
              color #FFFFFF
              font-size 12px
            .not-uploaded-tag
              width 50px
              height 24px
              line-height 24px
              text-align center
              background #4ABE7B
              border-radius 4px 0px 4px 0px
              color #FFFFFF
              font-size 12px
          &:hover .track-hover
            display block
          .row-time
            font-size 12px
            font-weight 400
            color #999999
          .download
            opacity 1
            bottom 22px
    .view-info
      .deviceDetail-class
        /deep/ .el-date-editor
          width 175px !important
          // border: 1px solid;
      .deviceDetail1-class
        /deep/ .el-date-editor
          width 156px !important
          .el-input__inner
            padding 12px 0 12px 22px!important
        >>>.el-input__prefix
          left 0!important
          // border: 1px solid;
      .deviceDetail2-class
        /deep/ .el-input
          width 185px !important
          // border: 1px solid;
      .status_info
        margin-top 10px
      .groups
        height 100%
      >>>.el-row
        height: calc(100% - 120px );
        .el-col-24
          height: 100%;
          .el-tabs
            height: 100%;
            .el-tabs__content
              height: calc(100% - 40px);
    table
      border-collapse collapse
      border-spacing 0
      width 100%
      height 520px
      text-align center
    td
      width 75%
      font-size 14px
      font-weight 400
    th
      font-size 14px
      font-weight 400
    .pagination
      position: absolute;
      bottom: 10px;
      right: 5px;
      >>>.el-pager li
        background #fff!important
        color: #333;
      >>>.el-pager li.active
        color: #409EFF
    .record-page
      width 160px
      height 20px
      text-align center
      font-size 14px
      line-height 20px
      margin 10px auto 0
    .pack-up
      height 63px
      width 24px
      bg-image('~@/icon/re-new-command/history/shrink.png')
      position absolute
      bottom 0
      left: -23px;
      cursor pointer
      writing-mode: vertical-lr;
      span
        font-size: 12px
        color #0E65DD
        position absolute
        top: 13px;
        left: 6px;
      i
        width 10px
        height 10px
        bg-image('~@/icon/re-new-command/history/arrow-right.png')
        display: inline-block;
        position: absolute;
        bottom: 3px;
        left: 7px;
/deep/ .el-button
  height 30px;/* no */
  padding 7px 15px!important;/* no */
/deep/ .el-image__placeholder
  bg-image-full('~@/icon/monitor/coverPlaceDark.png')
>>>.el-form-item
  margin-right 10px !important
  margin-bottom 10px !important
// 深色模式样式覆盖
.theme-dark
  .contain
   .shrink
    background #063184
    .title
      color #00E4FF
      bg-image('~@/icon/new-command/history/shrink-bg-m.png')
    .extend-up
      bg-image('~@/icon/re-new-command/history/shrink-m.png')
      span
        color #00E4FF
      i
        bg-image('~@/icon/re-new-command/arrow-left-m.png')
   .extend
      background #183D94
      #amplifyVideo
        background none
        bg-image('~@/icon/new-command/history/opacity-bg.png')
        .exVideoTitle
          color #00E4FF
          background url('~@/icon/newBg/img_head1-m.png') no-repeat
      .main
        .batch-manage
          .batch-btn
            color #00E4FF
        ul
          .row-list
            .row-header
              .row-title
                color #fff
    .main
      .pic_contrl
        .setNormalImp-icon
          bg-image('~@/icon/new-command/history/track-m.png')

        .setPicImp-icon
          bg-image('~@/icon/new-command/history/picture-m.png')

        .download-icon
          bg-image('~@/icon/new-command/history/download-m.png')

        .download-icon-delete
          bg-image('~@/icon/new-command/history/delet-m.png')

    .title
      bg-image('~@/icon/new-command/history/expand-bg-m.png')
      color #00E4FF
    .pack-up
      bg-image('~@/icon/re-new-command/arrow-right-bg-m.png')
      span
        color #00E4FF
      i
        bg-image('~@/icon/re-new-command/arrow-right-m.png')
    .view-info
      /deep/.el-form-item__label
        color #fff
      .pagination
        >>>.el-pager li
          background #041D5D!important
          color: #fff;
        >>>.el-pager li.active
          color: #409EFF
>>>.el-popper {
  width: 100% !important; /* no */
}
</style>
